import { SET } from '..';

export default {
	namespaced: true,
	state: {
		layout: 'simple-layout', // Initial selected layout. Before we enter portal or salon mode
	},
	getters: {
		layout: state => {
			return state.layout
		}
	},
	mutations: {
		SET
	},
	actions: {
        async setLayout({ commit }, { layout = 'portal-layout' }) { // Fallback when nothing entered
			if (layout) {
				commit('SET', { key: 'layout', value: layout });
			}

			return layout;
		}
	}
};
